/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiHttpBody } from '../../models/api-http-body';

export interface AdminServiceGetAltArtImageData$Params {
  gachaId: string;
  altArtId: number;
}

export function adminServiceGetAltArtImageData(http: HttpClient, rootUrl: string, params: AdminServiceGetAltArtImageData$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiHttpBody>> {
  const rb = new RequestBuilder(rootUrl, adminServiceGetAltArtImageData.PATH, 'get');
  if (params) {
    rb.path('gachaId', params.gachaId, {});
    rb.path('altArtId', params.altArtId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiHttpBody>;
    })
  );
}

adminServiceGetAltArtImageData.PATH = '/api/v3/gateway/admin/PRODUCTION/gacha/{gachaId}/alt_art/{altArtId}/image/raw';
